import PiPopupWindowPreview from "../previews/components/PiPopupWindowPreview";
import PiPopupWindowStaticTitle from "../previews/components/PiPopupWindowStaticTitle";
import SequencePreviewBody from "./SequencePreviewBody";

export default function SequencePreview() {
  // todo maximize window
  const title = <PiPopupWindowStaticTitle title="Sequence" />;

  return (
    <PiPopupWindowPreview
      title={title}
      body={<SequencePreviewBody />}
      size="full"
    />
  );
}
